import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      setParentFormField, // via ParentForm
      setAccountFormField // via NewAccount
    } = props

    const setFormField = setParentFormField || setAccountFormField

    const handleChangeFormField = fieldName => event => {
      if (fieldName === 'smsOptIn') {
        setFormField('smsOptedAt', new Date())
      }
      setFormField(fieldName, event.target.value)
    }

    return (
      <WrappedComponent {...props} onChangeFormField={handleChangeFormField} />
    )
  }
}

export default withEventHandlers
